var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector, useQuery } from '../../../../hooks';
import { selectMatchState, setMatchState } from '../../../../store/match';
import { DeskPool } from '../../DeskPool';
import { startPlayerIntroduction, startPlayerVote } from '../../../../api';
import { useErrorHandler } from '../../../../hooks/useErrorHandler';
export function StartRound({ useCase }) {
    var _a;
    const { param: matchId } = useQuery('matchId');
    const { errorHandler } = useErrorHandler(matchId);
    const dispatch = useAppDispatch();
    const [selectedPlayerId, setSelectedPlayerId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const matchState = useAppSelector(selectMatchState);
    const isMountedRef = useRef(true);
    useEffect(() => {
        return () => {
            isMountedRef.current = false;
        };
    }, []);
    const onGameButtonClick = () => __awaiter(this, void 0, void 0, function* () {
        console.log('onGameButtonClick');
        if (selectedPlayerId === null) {
            return;
        }
        if (!isMountedRef.current)
            return;
        setIsLoading(true);
        try {
            if (useCase === 'INTRODUCTION') {
                const result = yield startPlayerIntroduction(selectedPlayerId);
                console.log('INTRODUCTION start', result);
                if (isMountedRef.current) {
                    dispatch(setMatchState(result));
                }
            }
            else {
                const result = yield startPlayerVote(selectedPlayerId);
                console.log('VOTE start', result);
                if (isMountedRef.current) {
                    dispatch(setMatchState(result));
                }
            }
        }
        catch (err) {
            if (isMountedRef.current) {
                errorHandler(err);
            }
            console.error('onGameButtonClick error', err.response);
        }
        finally {
            if (isMountedRef.current) {
                setIsLoading(false);
            }
        }
    });
    const currentPlayer = (_a = matchState === null || matchState === void 0 ? void 0 : matchState.players) === null || _a === void 0 ? void 0 : _a.find((p) => p.id === selectedPlayerId);
    const gameButtonState = useMemo(() => ({
        text: isLoading ? 'Выполняется...' : `${currentPlayer === null || currentPlayer === void 0 ? void 0 : currentPlayer.player.gameName} - первый`,
        visible: selectedPlayerId !== null,
        onClick: onGameButtonClick,
        disabled: isLoading,
    }), [selectedPlayerId, isLoading]);
    return (_jsx(DeskPool, { onPlayerClickAction: (playerId) => setSelectedPlayerId(playerId), gameButtonState: gameButtonState }));
}
